import { render, staticRenderFns } from "./ArchiveTender.vue?vue&type=template&id=76e90da3&scoped=true&"
import script from "./ArchiveTender.vue?vue&type=script&lang=js&"
export * from "./ArchiveTender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e90da3",
  null
  
)

export default component.exports